import { Component, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContratoService } from 'src/app/contrato';
import { RelatorioService } from '../relatorio.service';

@Component({
    selector: 'app-usuarios-por-beneficiaria',
    templateUrl: './usuarios-por-beneficiaria.component.html',
    styleUrls: ['./usuarios-por-beneficiaria.component.css'],
    standalone: false
})
export class UsuariosPorBeneficiariaComponent extends GenericRelatorioComponent implements OnInit{
  
  breadcrumb: Breadcrumb[] = [
          { label: 'Início' },
          { label: 'Relatórios', route: '/relatorio' },
          { label: 'Usuários por Beneficiária' },
  ]

  dataSource: any[];
  pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
  columns: GenerateTableColumn[] = [
      { header: '#', attr: 'index' },
      { header: 'Nome', attr: 'nome' },
      { header: 'CNH', attr: 'cnh' },            
      { header: 'Validade CNH', attr: 'validade_cnh' },
      {
        header: 'Status CNH',
        template: (rowData: any) => `
            <span class="status-badge text-white ${rowData.status_cnh === 'OK' ? 'bg-success' : 'bg-danger'}">
                ${rowData.status_cnh}
            </span>`
      },
      { header: 'Dias para Vencer a CNH', attr: 'dias_para_vencer' },
      { header: 'Status Usuário', attr: 'status_usuario' },
  ];

  constructor(
    private relatorioService: RelatorioService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {
    super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    this.toggleFilters = true;
  }

  setBeneficiaria(beneficiaria: Beneficiaria) {
    this.filters.contrato = undefined;
    if (beneficiaria?.id) {
      this.buscaContratos(beneficiaria.id);
    } else {
      this.contratos = [];
    }
  }

  search(pageEvent?: GenerateTablePageEvent) {
    this.loading = true;
    this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current;
    this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize;

    const filters = { ...this.filters };

    this.relatorioService.getRelatorioUsuariosPorBeneficiaria(filters, this.pagination.current, this.pagination.pageSize).subscribe({
        next: (res: any) => {
            if (res.report.data) {
                this.dataSource = res.report.data.map((item: any, index: number) => this.buildResponse(item, index));
            }
            this.pagination.total = res.report.total;
        }
    }).add(() => this.loading = false);
  }

  buildResponse(item: any, index: number) {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    
    let statusCnh = '-';
    let diasParaVencer = '-';
    
    if (item.validade_cnh) {
      const dataValidade = new Date(item.validade_cnh);
      dataValidade.setHours(0, 0, 0, 0);
      
      // Calcula diferença em dias
      const diffTime = dataValidade.getTime() - hoje.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      // Status CNH
      if (diffDays < 0) {
        //statusCnh = '<span style="color: red; font-weight: bold;">VENCIDA</span>';
        statusCnh = 'VENCIDA';
      } else {
        statusCnh = 'OK';
      }
            
      diasParaVencer = diffDays.toString();      
    }
    
    return {
      index: index + 1,
      nome: item.nome,
      cnh: item.cnh ? item.cnh.toUpperCase() : '-',
      validade_cnh: item.validade_cnh ? new Date(item.validade_cnh).toLocaleDateString() : '-',
      status_cnh: statusCnh,
      dias_para_vencer: diasParaVencer,
      status_usuario: item.ativo ? 'Ativo' : 'Inativo'
    };
  }

  export(type: string = 'csv') {
    this.loading = true;

    const filters = { ...this.filters, removePaingation: true };

    this.relatorioService.downloadArquivoCsvOrPdf(filters, 'usuarios-por-beneficiaria', type).subscribe({
        next: (res: any) => {
            const url = window.URL.createObjectURL(res.body as Blob);
            const fileName = `Usuarios_por_beneficiaria_${dayjs().format('DD-MM-YYYY')}`;
            const anchor = document.createElement('a');
            anchor.download = `${fileName}.${type}`;
            anchor.href = url;
            anchor.click();
            this.toggleFilters = false;
            this.loading = false;
        },
        error: (err) => console.log('err', err)
    });
  }

}
